export default __webpack_public_path__ + "static/media/directions-iHunt-1.1a7983b1.jpg";